export default {
      id: "ideas copy-usage",
      viewBox: "0 0 350.42 512",
      url: __webpack_public_path__ + "img/svg-sprite.svg#ideas copy",
      toString: function () {
        return this.url;
      }
    }